import { Pipe, PipeTransform } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'

@Pipe({
  name: 'safeUrl'
})
export class SafeResourceUrlPipe implements PipeTransform {

  constructor (protected sanitizer: DomSanitizer) {
  }

  transform (url?: string) {
    return url && this.sanitizer.bypassSecurityTrustResourceUrl(url) || ''
  }
}
